module.exports = __webpack_public_path__ + "img/embudo_ventas.86478c46.png";